export default __webpack_public_path__ + "static/media/contact1.e788e470.jpg";